document.addEventListener('DOMContentLoaded', function() {
  /*********************************************************************
   * 1) Define your entire collection hierarchy in `collectionMap`
   *********************************************************************/
  const collectionMap = {
    /* ----------- Abrasives (existing) ----------- */
    'abrasives': { displayName: 'Abrasives', parent: null },
    'abrasives-belts-2-x-72': { displayName: 'Belts 2" x 72"', parent: 'abrasives' },
    'aluminum-oxide-2-x-72-belts': { displayName: 'Aluminum Oxide', parent: 'abrasives-belts-2-x-72' },
    'ceramics': { displayName: 'Ceramics', parent: 'abrasives-belts-2-x-72' },
    'structured-abrasives': { displayName: 'Structured Abrasives', parent: 'abrasives-belts-2-x-72' },
    'surface-conditioning-scotchbrite-vortex': { displayName: 'Surface Conditioning', parent: 'abrasives-belts-2-x-72' },
    'zirconia': { displayName: 'Zirconia', parent: 'abrasives-belts-2-x-72' },
    'sand-paper-sheets-knife-handles': { displayName: 'Sandpaper', parent: 'abrasives' },

    /* -------- Buffing and Polishing (existing) -------- */
    'buffing-and-polishing': { displayName: 'Buffing and Polishing', parent: null },
    'hand-polish-finish-and-protection': {
      displayName: 'Hand Polish, Finish and Protection',
      parent: 'buffing-and-polishing'
    },
    'buffing-wheels': { displayName: 'Buffing Wheels', parent: 'buffing-and-polishing' },
    'buffing-compounds': { displayName: 'Buffing Compounds', parent: 'buffing-and-polishing' },

    /* ---- Grinders & Moen Grinding Jig, Tools (existing) ---- */
    'grinders-kmg-the-knife-makers-grinder': {
      displayName: 'Grinders & Parts & Accessories',
      parent: null
    },
    'kmg-grinders': { displayName: 'KMG Grinders', parent: 'grinders-kmg-the-knife-makers-grinder' },
    'kmg-parts-and-accessories': { displayName: 'KMG Parts & Accessories', parent: 'grinders-kmg-the-knife-makers-grinder' },
    'kmg-small-wheels': { displayName: 'KMG Small Wheels', parent: 'grinders-kmg-the-knife-makers-grinder' },
    'new-blade-grinding-fixture': { displayName: 'Moen Grinding Jig & Tools', parent: 'grinders-kmg-the-knife-makers-grinder' },

    /* ------------- Kydex & Accessories (existing) ------------- */
    'kydex-and-related': { displayName: 'Kydex & Accessories', parent: null },
    'kydex-sheets': { displayName: 'Kydex Sheets', parent: 'kydex-and-related' },
    'kydex-accessories': { displayName: 'Kydex Accessories', parent: 'kydex-and-related' },

    /* ----- Heat Treat Recipes & Supplies (existing) ----- */
    'heat-treating-supplies': { displayName: 'Heat Treat Recipes and Supplies', parent: null },
    'heat-treat-service': { displayName: 'Heat Treat Service', parent: 'heat-treating-supplies' },

    /* ============= Handle Materials ============= */
    'handle-materials': { displayName: 'Handle Materials', parent: null },
          'hardwood-non-stabilized': { displayName: 'Hardwood - Non-Stabilized', parent: 'handle-materials' },

           'grip-tec': { displayName: 'Grip Tec', parent: 'handle-materials' },

        'ameragrip': { displayName: 'AmeraGrip', parent: 'handle-materials' },
    'carbon-fiber': { displayName: 'Carbon Fiber', parent: 'handle-materials' },
    'crazyfiber': { displayName: 'Crazyfibre', parent: 'handle-materials' },
    'elforyn-super-tusk-ivory-substitute': {
      displayName: 'Elforyn "Super Tusk" Ivory Substitute',
      parent: 'handle-materials'
    },
    'stabilized-wood-handle-material-raffir-poplar': {
      displayName: 'Hardwood - Stabilized',
      parent: 'handle-materials'
    },
    'horn-antler': { displayName: 'Horn / Antler / Bone', parent: 'handle-materials' },
    'juma-gem-and-exotic': { displayName: 'Juma Gem & Exotic', parent: 'handle-materials' },
    'raffir-uranium': {
      displayName: 'Raffir Composites (Uranium, Wasp, Heatwave)',
      parent: 'handle-materials'
    },
    // Synthetic sub-collection
    'synthetic-handle-materials': {
      displayName: 'Synthetic Handle Materials - Spacer, G-10, Micarta',
      parent: 'handle-materials'
    },
    'g-10-spacers-knife-handle': {
      displayName: 'G-10 Spacers - 1/32" & 1/16"',
      parent: 'synthetic-handle-materials'
    },
    'g-10-1-8': { displayName: 'G-10 1/8"', parent: 'synthetic-handle-materials' },
    'g10-1-4-inch': { displayName: 'G10 1/4"', parent: 'synthetic-handle-materials' },
    'g-10-3-8': { displayName: 'G10 3/8"', parent: 'synthetic-handle-materials' },
    'micarta-linen-canvas-burlap-knife-handle': {
      displayName: 'Micarta 3/8" + 1/4"',
      parent: 'synthetic-handle-materials'
    },
    'fiber-spacer-knife-handle-material': {
      displayName: 'Fiber Spacer Material',
      parent: 'synthetic-handle-materials'
    },

    /* ============= Hardware ============= */
    'hardware': { displayName: 'Hardware', parent: null },
    '416-stainless-pinstock-and-bars': {
      displayName: '416 Stainless - Pinstock & Bars',
      parent: 'hardware'
    },
    'brass-bar-pins-and-tubes': {
      displayName: 'Brass - Pinstock, Tubes, & Bars',
      parent: 'hardware'
    },
    'copper-bar-and-pins': {
      displayName: 'Copper - Pinstock & Bars',
      parent: 'hardware'
    },
    'decorative-and-mosaic-handle-pins': {
      displayName: 'Decorative & Mosaic - Pins',
      parent: 'hardware'
    },
    'corby-bolts': {
      displayName: 'Fasteners - Colby Bolts',
      parent: 'hardware'
    },
    'g-10-rods': {
      displayName: 'G-10 - Pinstock',
      parent: 'hardware'
    }
  };


  const productOverrides = {
    'ameragrip': 'AmeraGrip - 1/4"x 6" x 12"'      // <- the text you asked for
    // add more overrides here if needed
  };
  
  /*********************************************************************
   * 2) Grab the container for the dynamic breadcrumb
   *********************************************************************/
  const breadcrumbContainer = document.getElementById('dynamic-breadcrumb');
  if (!breadcrumbContainer) return; // If no container, do nothing

  /*********************************************************************
   * 3) Parse the current URL path
   *********************************************************************/
  const pathSegments = window.location.pathname
    .split('/')
    .filter(seg => seg.length > 0);

  // 4) Must be /collections/<handle> or /collections/<handle>/products/<handle>
  if (pathSegments[0] !== 'collections') {
    return; // Not a recognized collection route => no dynamic breadcrumb
  }

  let collectionHandle = pathSegments[1] || null;
  let productHandle = null;

  // If path is "/collections/<handle>/products/<product-handle>"
  if (pathSegments[2] === 'products' && pathSegments[3]) {
    productHandle = pathSegments[3];
  }

  // If no valid collection handle, stop
  if (!collectionHandle) {
    return;
  }

  /*********************************************************************
   * 5) Build the chain from this sub-collection up to top-level
   *********************************************************************/
  let chain = [];
  let current = collectionHandle;

  while (current && collectionMap[current]) {
    const node = collectionMap[current];
    chain.push({ handle: current, name: node.displayName });
    current = node.parent;
  }

  // If chain is empty => unrecognized handle => skip
  if (chain.length === 0) {
    return;
  }

  // Reverse chain so top-level -> sub-level
  chain.reverse();

  /*********************************************************************
   * 6) For the product name, parse document.title & remove extra suffixes
   *********************************************************************/
  let productName = null;
  if (productHandle) {
    let rawTitle = document.title;

    // 1) Remove any trailing "| KnifeMaker" (with optional preceding spaces)
    rawTitle = rawTitle.replace(/\s*\|\s*KnifeMaker\s*$/, '');

    // 2) Remove any trailing "- Knife Making Tools" (with optional preceding spaces)
    rawTitle = rawTitle.replace(/\s*-\s*Knife Making Tools\s*$/, '');
 
    
    rawTitle = rawTitle.replace(/\s*-\s*Knife Making Handle Supplies\s*$/, '');

    rawTitle = rawTitle.replace(/\s*-\s*Custom Knife Handle\s*$/, '');
         rawTitle = rawTitle.replace(/\s*-\s*Knife Making Supplies\s*$/, '');
         rawTitle = rawTitle.replace(/\s*-\s*Knife Sheath Material\s*$/, '');

         rawTitle = rawTitle.replace(/\s*-\s*Custom Knife Making\s*$/, '');

         rawTitle = rawTitle.replace(/\s*-\s*Heat Treatment\s*$/, '');

         rawTitle = rawTitle.replace(/\s*-\s*Knife Making Handle Material\s*$/, '');

             rawTitle = rawTitle.replace(/\s*-\s*Knife Handle Material\s*$/, '');
             rawTitle = rawTitle.replace(/\s*-\s*Custom\s*$/, '');
        rawTitle = rawTitle.replace(/\s*Custom Knife Making\s*$/, '');
        rawTitle = rawTitle.replace(/\s*Knife Handle Material\s*$/, '');
        rawTitle = rawTitle.replace(/\s*Knife Making Handle Material\s*$/, '');
        rawTitle = rawTitle.replace(/\s* Handle Material\s*$/, '');

             rawTitle = rawTitle.replace(/\s*-\s*Knifemaking\s*$/, '');



    productName = rawTitle;
  }

  /*********************************************************************
   * 7) Render the dynamic breadcrumb as <ul> with ">" separators
   *********************************************************************/
  let breadcrumbHtml = '<ul>';

  // "Home" link
  breadcrumbHtml += `
    <li><a href="/">Home</a> &gt;</li>
  `;

  // Each collection crumb
  chain.forEach((col, idx) => {
    const url = '/collections/' + col.handle;
    const isLastCollection = (idx === chain.length - 1);
    const hasProduct = !!productName;
    let separator = '';

    // If there's more chain left or a product, append ">"
    if (!isLastCollection || hasProduct) {
      separator = ' &gt;';
    }

    breadcrumbHtml += `
      <li>
        <a href="${url}">${col.name}</a>${separator}
      </li>
    `;
  });

  // Product crumb if present
  if (productName) {
    breadcrumbHtml += `
      <li>
        <a href="/collections/${collectionHandle}/products/${productHandle}">${productName}</a>
      </li>
    `;
  }

  breadcrumbHtml += '</ul>';

  /*********************************************************************
   * 8) Insert the breadcrumb & hide default
   *********************************************************************/
  breadcrumbContainer.innerHTML = breadcrumbHtml;

  if (breadcrumbHtml !== '<ul></ul>') {
    const defaultBreadcrumb = document.querySelector('.breadcrumbs');
    if (defaultBreadcrumb) {
      defaultBreadcrumb.style.display = 'none';
    }
  }
});
